<template>
    <div class="error-page">
        <div>
            <section class="message">
                <h2>{{ $t('common.error pages.whoops') }}</h2>
                <p>{{ $t('common.error pages.connection error desc') }}</p>
                <button @click="reload">{{ $t('common.error pages.reload') }}</button>
            </section>
            <section class="info">
                <h2>{{ $t('common.error pages.connection error') }}</h2>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        reload() {
            location.reload();
        }
    }
}
</script>
